import API from "./api";
import * as Sentry from "@sentry/react";
import { storage } from "services/config/storage";
import { GC } from "services/config/gamecentreService";

const logError = (error) => {
  if (error?.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    Sentry.setExtra("response", error.response);
    Sentry.captureException(error);
  } else if (error?.request) {
    // The request was made but no response was received
    Sentry.setExtra("request", error.request);
    Sentry.captureException(error);
  } else {
    // Something happened in setting up the request that triggered an Error
    Sentry.captureException(error?.message);
  }
};

export function sendResult(result) {
  GC.sendGameDataSaveMessage(result);
}

// export function sendResult(result) {
//   const gameId = storage.get.gameId();
//   const authToken = storage.get.authToken();
//   const gameplayId = storage.get.gameplayId();

//   if (!(gameId || authToken || gameplayId)) {
//     console.error("Session not found ::", { gameId, authToken, gameplayId });
//     return null;
//   }

//   API.post(
//     `${process.env.REACT_APP_API_ENDPOINT}/api/session/v1/${gameId}/link/${gameplayId}`,
//     {
//       ...result,
//     },
//     {
//       headers: {
//         Authorization: authToken,
//       },
//     }
//   )
//     .then((result) => {
//       console.log("SUCCESSFULLY UPDATED THE DATA IN THE BACKEND!");
//       return true;
//     })
//     .catch((error) => {
//       console.error(
//         `ERROR::${process.env.REACT_APP_GAME_NAME}::getGameId::${error}`
//       );
//       console.log("ERROR WHILE FEEDING DATA TO BACKEND!");
//       logError(error);
//       return false;
//     });
// }
